module.exports = __webpack_public_path__ + "images/ExternalPromo/wix-footer-401.png?67154";